import './SidebarPrintdemand.scss'

import {Picture} from '@codeurs/front'
import React from 'react'
import {ImageType, WysiwygType} from '../../types'
import {style} from '../../util/style'
import {Block} from '../blocks/Blocks'
import {Theme} from '../Theme'

const styles = style('sidebarprintdemand')

export type SidebarPrintdemandType = {
	image: ImageType
	text?: WysiwygType
}

export const SidebarPrintdemand: React.FC<SidebarPrintdemandType> = ({
	image,
	text
}) => {
	if (!image && !text) return null

	return (
		<Block className={styles().mod({image})} sidebar={true}>
			{image && image.src && (
				<div className={styles('image')}>
					<Picture className={styles('image-img').toString()} {...image} />
				</div>
			)}
			{text && (
				<div className={styles('content')}>
					<div className={styles('text')}>
						<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
					</div>
				</div>
			)}
		</Block>
	)
}
